import { render, staticRenderFns } from "./SummaryReportTab.vue?vue&type=template&id=5a80b0b1&scoped=true&"
import script from "./SummaryReportTab.vue?vue&type=script&lang=js&"
export * from "./SummaryReportTab.vue?vue&type=script&lang=js&"
import style0 from "./SummaryReportTab.vue?vue&type=style&index=0&id=5a80b0b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a80b0b1",
  null
  
)

export default component.exports